<template>
  <div class="payPalMethod">
    <paypal-method></paypal-method>
  </div>
</template>

<script>
// @ is an alias to /src
import paypalMethod from "@/components/methods/paypalMethod.vue";

export default {
  name: "paypl",

  components: {
    paypalMethod
  },
  created() {
    console.log("PayPal");
  }
};
</script>

